// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","avatar":"Header_avatar__fR3aq","headerText":"Header_headerText__no-LG","greenActiveDot":"Header_greenActiveDot__ylOwj"};